import React from 'react'
import styled from 'styled-typed'
import { ValidationMessage } from 'auth/components'
import { FormItem, FormItemName } from 'uiComponents/form/formElements'
import { LucideIcon, LucideIconName } from 'utils/lucideIcon'
import './fieldWrapper.scss'
import classNames from 'classnames'
import { FontWeightType } from 'uiComponents/typography'

export type FieldStatus = 'error' | 'normal' | 'success' | 'highlight'

export type FieldVariant = 'default' | 'inline' | 'inline-reverse'

interface FieldContainerProps {
    variant?: FieldVariant
}

const FieldContainer = styled.div<FieldContainerProps>`
    display: ${(props) => (!!props.variant ? 'flex' : 'inherit')};

    ${(props) =>
        props.variant === 'inline' || props.variant === 'inline-reverse'
            ? `
            & > .label {
                margin: 0;
            }
        `
            : ''}

    ${(props) =>
        props.variant === 'inline'
            ? `
            & > .label {
                padding-right: 1rem;
            }
        `
            : ''}
`

export interface FieldWrapperProps {
    children?: React.ReactNode
    error?: string
    label?: string | React.ReactNode
    id?: string
    status: FieldStatus
    validationMessageProps?: any
    variant?: FieldVariant
    className?: string
    labelProps?: any
    icon?: LucideIconName
    fontWeight?: FontWeightType
}

const FieldWrapper: React.FC<FieldWrapperProps> = ({
    children,
    error,
    label,
    id,
    status,
    validationMessageProps = {},
    variant,
    className,
    labelProps,
    icon,
    fontWeight = 'medium',
}) => {
    const shouldShowError = status === 'error'

    return (
        <FormItem className={classNames('field-wrapper', className)} htmlFor={id}>
            <FieldContainer variant={variant}>
                {variant === 'inline-reverse' ? (
                    <>
                        {children}
                        {!!label && (
                            <FormItemName weight={fontWeight} size={1} className="label" {...labelProps}>
                                {label}
                                {icon && <LucideIcon iconName={icon} className="field-wrapper-icon" />}
                            </FormItemName>
                        )}
                    </>
                ) : (
                    <>
                        {!!label && (
                            <FormItemName weight={fontWeight} size={1} className="label" {...labelProps}>
                                {icon && <LucideIcon iconName={icon} className="field-wrapper-icon" />}
                                {label}
                            </FormItemName>
                        )}
                        {children}
                    </>
                )}
            </FieldContainer>
            <ValidationMessage
                {...validationMessageProps}
                className={shouldShowError ? 'validation-message-visible' : ''}
            >
                {shouldShowError && error}
            </ValidationMessage>
        </FormItem>
    )
}

export default FieldWrapper
